import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

export const AnimationType = {
  slideInDown: 'slideInDown',
  fade: 'fade',
  fadeInDown: 'fadeInDown'
};

class CssAnimation extends Component {
  render() {
    const { isVisible, animateAppear, animateLeave, children, type, timeout } = this.props;

    return (
      <CSSTransition
        in={isVisible}
        appear={animateAppear}
        exit={animateLeave}
        classNames={type}
        timeout={timeout}
        unmountOnExit
      >
        {children}
      </CSSTransition>
    );
  }
}

CssAnimation.AnimationType = AnimationType;

CssAnimation.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([AnimationType.slideInDown, AnimationType.fade, AnimationType.fadeInDown])
    .isRequired,
  animateAppear: PropTypes.bool.isRequired,
  animateLeave: PropTypes.bool.isRequired,
  timeout: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

CssAnimation.defaultProps = {
  timeout: 300,
  isVisible: true,
  animateAppear: true,
  animateLeave: true
};

export default CssAnimation;
